<div class="banner-slot">
  @if (apiError(); as message) {
    <p class="banner-text">
      <span class="banner-row">
        <span class="banner-icon" aria-hidden="true">⚠</span>
        {{ message }}
      </span>
    </p>
  }
</div>
